import { render, staticRenderFns } from "./AvgTimeAttention.vue?vue&type=template&id=729ef118&scoped=true"
import script from "./AvgTimeAttention.vue?vue&type=script&lang=js"
export * from "./AvgTimeAttention.vue?vue&type=script&lang=js"
import style0 from "./AvgTimeAttention.vue?vue&type=style&index=0&id=729ef118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729ef118",
  null
  
)

export default component.exports